import './news-media-wrapper.scss';

/**
 * version    1.0
 * class      <type> (news media wrapper)
 * classdesc  Component that manage the news media wrapper
 */
export class NewsMediaWrapper {}
